module.exports = __webpack_public_path__ + "img/weddings_05_H.1418e020.jpg";